import { useEffect, useRef, useState } from 'react';
import { createI18nContext } from '@aviv-unified-frontend/runtime/i18n';
import { TLocale } from '@aviv-estimation-funnel/shells/src/app/helpers/i18n';

const useI18nContext = (language: TLocale) => {
    const [loading, setLoading] = useState(true);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const context = useRef<any>();

    useEffect(() => {
        context.current = createI18nContext({
            locale: language,
        });

        setLoading(false);
    }, [language]);

    return { loading, I18N_CONTEXT: context.current };
};

export default useI18nContext;
